import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PGHAppLoadService } from "../services/pgh-app-load.service";

@Injectable()
export class SiteConfigResolver  {
  constructor(private resourcesLoader: PGHAppLoadService) {}
  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
    var data =  this.resourcesLoader.loadSiteResources();
    console.log("Site resoruces loaded");
    return data;
  }
}
